import { getBaseFilename, getFileExtension } from '../utilities/fileProcessingUtilities';
import { UploadedFile } from './UploadedFile';

export class FileFromBrowserUpload implements UploadedFile {
  source: File;

  filetype: string | null;
  filename: string;

  contents?: string;

  constructor(source: File) {
    this.source = source;

    this.filename = getBaseFilename(source.name);
    this.filetype = getFileExtension(source.name);
  }

  getContents(): Promise<string> {
    if (this.contents) {
      return Promise.resolve(this.contents);
    }

    return new Promise<string>((res, rej) => {
      const reader = new FileReader();

      reader.onerror = (err) => rej(err);
      reader.onload = () => {
        this.contents = reader.result as string;
        res(reader.result as string);
      };

      reader.readAsDataURL(this.source);
    });
  }

  static fromList(source: FileList) {
    return Array.from(source).map((file) => new FileFromBrowserUpload(file));
  }
}
